import { useState, useCallback } from 'react';

import { useKeyPress } from '@/lib/hooks/use-key-press';

import { OverlayContextProvider } from '@/components/overlay/overlay-context-provider';

import { ContextMenuOptions, ContextMenuContext } from './context-menu-context';

import { ContextMenu } from '.';

import styles from '../dropdown/dropdown.module.scss';

export function ContextMenuContextProvider({ children }: { children: React.ReactNode }) {
  const [menus, setMenus] = useState<ContextMenuOptions[]>([]);
  const menuOpen: boolean = menus.length > 0;

  const openContextMenu = useCallback(
    (menu: ContextMenuOptions) => {
      menu.onOpen?.();
      setMenus((menus) => [...menus, menu]);
    },
    [setMenus],
  );

  const closeContextMenu = (idx: number) => {
    const menu = menus[idx];
    menu.onClose?.();
    setMenus((menus) => menus.filter((_, i) => i !== idx));
  };

  useKeyPress(
    'Escape',
    (e: KeyboardEvent) => {
      if (menuOpen) {
        e.preventDefault();
        e.stopPropagation();
        closeContextMenu(0);
      }
    },
    { capture: true },
  );

  return (
    <ContextMenuContext.Provider value={{ openContextMenu }}>
      {menus.map(({ items, position: { x, y } }, idx) => (
        <div key={idx} className={styles.backdrop} onClick={() => closeContextMenu(idx)}>
          <OverlayContextProvider>
            <ContextMenu
              items={items}
              x={x}
              y={y}
              closeContextMenu={() => closeContextMenu(idx)}
              isOpen
            />
          </OverlayContextProvider>
        </div>
      ))}
      {children}
    </ContextMenuContext.Provider>
  );
}
